// import Swiper JS
import Swiper, {Navigation, Pagination, Autoplay} from "swiper"

const productHero = document.querySelector(".product-hero")

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

if (productHero) {

  let currentHeroSlide = productHero.querySelector(".current-slide")
  let totalHeroSlides = productHero.querySelector(".total-slide")

// init Swiper:
  const heroCarousel = new Swiper('.product-hero__carousel', {
    loop: true,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: false,
      disableOnInteraction: false,
      reverseDirection: false
    },
    watchOverflow: true,

    // bullets
    pagination: {
      el: '.swiper-pagination'
    },

    // arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    runCallbacksOnInit: true,

    on: {
      init: function (el) {
        currentHeroSlide.innerHTML = el.activeIndex + 1
        totalHeroSlides.innerHTML = el.slides.length
      },
      slideChange: function (el) {
        currentHeroSlide.innerHTML = el.activeIndex + 1
        totalHeroSlides.innerHTML = el.slides.length
      },
    },
  })

// hide Swiper controls if there is just one slide
  let carouselContainer = document.querySelector('.product-hero__carousel')
  let carouselSlides = carouselContainer.querySelectorAll('.swiper-slide')
  let carouselControls = carouselContainer.querySelector('.swiper-controls')

  if (carouselSlides.length <= 1) {
    carouselControls.style.display = 'none'
  }

}
